import Enum from '@ks/enum';

export enum PopulationStatus {
    INVALID = 0,
    VALID = 1,
    DELETED = 2,
    PUSHING = 3,
    PUSHED = 4,
    COMPUTE_FAIL = 5,
    PUSH_FAIL = 6,
    OVERDUE = 7,
    SOON_INVALID = 8,
}

export const POPULATION_STATUS = {
    [PopulationStatus.INVALID]: '计算中',
    [PopulationStatus.VALID]: '已生效',
    [PopulationStatus.DELETED]: '已删除',
    [PopulationStatus.PUSHING]: '上线中',
    [PopulationStatus.PUSHED]: '已上线',
    [PopulationStatus.COMPUTE_FAIL]: '计算失败',
    [PopulationStatus.PUSH_FAIL]: '上线失败',
    [PopulationStatus.OVERDUE]: '已失效',
    [PopulationStatus.SOON_INVALID]: '即将失效',
};

export const POPULATION_TYPE = {
    1: '上传人群',
    2: '广告人群',
    3: '主题专区',
    4: '逻辑规则',
    5: '人群扩展',
    6: '平台定制',
    7: '定制付费',
    8: '网红粉丝类别',
    9: '内容付费行为',
    10: '移动应用安装',
    11: '快手使用活跃度',
    12: '行业分类',
    13: '商业兴趣',
    15: '行业偏好',
    17: '产品关键词',
    19: '应用渗透率',
    20: '快手小店',
    21: 'SQL匹配人群',
    22: '网红粉丝类别',
    23: '行业分类',
    24: '广告人群',
    25: '网红粉丝类别',
    26: '移动应用安装',
    27: '平台设备网络',
    40: '标签广场',
};

export const INDUSTRY_LIST = [12, 23];

export const ADVERTISE_LIST = [2, 24];

export const FANSTAR_LIST = [8, 22, 25];

export const MOBILEAPP_LIST = [10, 26];

export const SHOP_FOLLOW_TIME_LIST = [54, 98];

export const FILTER_POPULATION = [22, 23, 24, 25, 26];

export const PAID_POPULATION_TYPE = ['电商', '游戏', '教育', '工具', '社交/婚恋', '求职/招聘'];

export const ACTION_TYPE = {
    2: '行为点击',
    11: '封面点击',
};

export const POPULATION_UPLOAD_TYPE = {
    IMEI: 1,
    IDFA: 2,
    'IMEI-md5': 3,
    'IDFA-md5': 4,
    '手机号-md5': 5,
    UID原值: 6,
    OAID: 7,
    'OAID-md5': 8,
    '手机号-sha256': 9,
    CAID: 16,
};

// IMEI、IMEImd5、IDFA、IDFAmd5、OAID、OAIDmd5 的枚举值时，展示类型匹配
export const POPULATION_UPLOAD_MATCH_TYPE_LIST = [
    POPULATION_UPLOAD_TYPE['IMEI'],
    POPULATION_UPLOAD_TYPE['IDFA'],
    POPULATION_UPLOAD_TYPE['IMEI-md5'],
    POPULATION_UPLOAD_TYPE['IDFA-md5'],
    POPULATION_UPLOAD_TYPE['OAID'],
    POPULATION_UPLOAD_TYPE['OAID-md5'],
];

export const POPULATION_UPLOAD_TYPE_TIPS = {
    IMEI: '15位数字，示例：123456789012345；或14位数字大小写字母组合，示例：A00000020C711A',
    IDFA: '8位-4位-4位-4位-12位, 数字大小写字母组合, 示例：1E2DFA89-496A-47FD-9941-DF1FC4E6484A',
    'IMEI-md5':
        '加密后的IMEI，加密后为32位数字大小写字母串，示例：7b71178Ab3c93eadb1cd216a58895bc3',
    'IDFA-md5':
        '加密后的IDFA，加密后为32位数字大小写字母串，示例：7BC8fd829daE56bbf980c3eAfc22135e',
    '手机号-md5':
        '加密后的手机号，加密前为11位的纯数字串，加密后为32位数字大小写字母串，示例：B3ef2c5a5E7d89010f79495a2a6c8b97',
    UID原值: '数字组合，示例：12345678',
    OAID: 'MSA 制定的匿名设备标识符原始值，数字小字母和连接线构成，格式不固定，示例：fe77dfff-ffeb-8650-d5b9-df97c5fe2b23',
    'OAID-md5':
        '加密后的OAID，加密后为32位数字大小写字母串，示例：d71fB78e84f5AAAed727867da2bcea79',
    '手机号-sha256':
        '加密后的手机号，加密前为 11 位的纯数字串，加密后为64位“数字(0-9)+小写字母(a-f)”组成的数字字母串，示例：e4d354e82b6efb120143215573b5a32267cf65a38c29a681eb3b726b29c29d8e',
    CAID: '32位数字字母组合，示例：7043e0d7babf1feeb64ce866d13f35b6',
};

export enum PopulationUploadTypeMatch {
    'Uid' = 'uid',
    'Did' = 'did',
}

export const POPULATION_UPLOAD_TYPE_MATCH_LIST = [
    {
        value: PopulationUploadTypeMatch.Uid,
        label: 'UID匹配',
    },
    {
        value: PopulationUploadTypeMatch.Did,
        label: '设备号匹配',
    },
];

export const POPULATION_OPERATE_TYPE = Enum({
    INTERSECTION: [0, '交集'],
    UNION: [1, '并集'],
    EXCLUDE: [2, '排除'],
});

export const PrecisionTypes = [
    {
        label: '曝光',
        tooltip: '素材曝光',
    },
    {
        label: '点击',
        tooltip: '行为数',
    },
    {
        label: '转化',
        tooltip: '后链路指标',
    },
];

export const PrecisionTypesOld = [
    {
        label: '一般精度人群',
        tooltip: '素材曝光的人群',
    },
    {
        label: '高精度人群',
        tooltip: '指定广告转化行为人群',
    },
];

const TransferPercisionOptions = Enum({
    DEFAULT: [0, '一般精度人群'],
    ACTIONBAR_CLICK: [1, '行为数'],
    DOWNLOAD_COMPLETE: [2, '下载完成'],
    INSTALL_COMPLETE: [3, '安装完成'],
    ACTIVATION: [4, '激活'],
    FORM: [5, '表单'],
    PAID: [6, '付费'],
    NEXTDAYSTAY: [7, '次留（APP）'],
    JINJIAN: [8, '完件'],
    CREDITGRANT: [9, '授信'],
    REGISTER: [15, '注册'],
    ADD_SHOPPING_CART: [10, '添加购物车'],
    BUY: [12, '购买'],
    BUY_FAKE: [11, '购买'], // 兼容前段时间创建时枚举值错误时的情况
    EFFECT_CLUE: [14, '有效线索'],
    INCREASE_FANS: [16, '涨粉量'],
    VISIT_SKU: [17, '商品访问'],
    EFFECT_STREAM_WATCH: [18, '有效直播观看'],
});

const IndustryPercisionOptions = Enum({
    DEFAULT: [0, '一般精度人群'],
    ACTIONBAR_CLICK: [1, '行为数'],
    DOWNLOAD_COMPLETE: [2, '下载完成'],
    INSTALL_COMPLETE: [3, '安装完成'],
    ACTIVATION: [4, '激活'],
    FORM: [5, '表单'],
    PAID: [6, '付费'],
    NEXTDAYSTAY: [7, '次留（APP）'],
    JINJIAN: [8, '完件'],
    CREDITGRANT: [9, '授信'],
    REGISTER: [15, '注册'],
    ADD_SHOPPING_CART: [10, '添加购物车'],
    BUY: [12, '购买'],
    EFFECT_CLUE: [14, '有效线索'],
    INCREASE_FANS: [16, '涨粉量'],
    VISIT_SKU: [17, '商品访问'],
    EFFECT_STREAM_WATCH: [18, '有效直播观看'],
});

export const PrecisionTooltip = {
    5: '二店账号表单提交即是订单提交 ',
};

export const PercisionOptions = {
    TRANSFER: TransferPercisionOptions,
    INDUSTRY: IndustryPercisionOptions,
    DEFAULT: TransferPercisionOptions,
};

export enum ACTION_ENUM {
    GEQ = 0,
    LSS = 1,
    BTW = 2,
}

export const ActionOptions = {
    0: '大于等于',
    1: '小于',
    2: '介于',
};

export const INTEREST_OPTION = [
    {
        label: '游戏类',
        value: 0,
        children: [
            { label: '跑酷竞速', checkable: true, value: '跑酷竞速' },
            { label: '扑克棋牌', checkable: true, value: '扑克棋牌' },
            { label: '网络游戏', checkable: true, value: '网络游戏' },
            { label: '动作射击', checkable: true, value: '动作射击' },
            { label: '儿童益智', checkable: true, value: '儿童益智' },
            { label: '休闲时间', checkable: true, value: '休闲时间' },
            { label: '角色扮演', checkable: true, value: '角色扮演' },
            { label: '体育格斗', checkable: true, value: '体育格斗' },
            { label: '音乐视听', checkable: true, value: '音乐视听' },
            { label: '经营策略', checkable: true, value: '经营策略' },
        ],
    },
    {
        label: '应用类',
        value: 1,
        children: [
            { label: '金融理财', checkable: true, value: '金融理财' },
            { label: '网上购物', checkable: true, value: '网上购物' },
            { label: '摄影图像', checkable: true, value: '摄影图像' },
            { label: '新闻阅读', checkable: true, value: '新闻阅读' },
            { label: '育儿亲子', checkable: true, value: '育儿亲子' },
            { label: '考试学习', checkable: true, value: '考试学习' },
            { label: '旅游出行', checkable: true, value: '旅游出行' },
            { label: '影音播放', checkable: true, value: '影音播放' },
            { label: '手机美化', checkable: true, value: '手机美化' },
            { label: '辅助工具', checkable: true, value: '辅助工具' },
            { label: '办公商务', checkable: true, value: '办公商务' },
            { label: '健康运动', checkable: true, value: '健康运动' },
            { label: '通讯社交', checkable: true, value: '通讯社交' },
            { label: '美容美发', checkable: true, value: '美容美发' },
            { label: '婚纱摄影', checkable: true, value: '婚纱摄影' },
            { label: '美妆护肤', checkable: true, value: '美妆护肤' },
            // { label: '汽车资讯', checkable: true, value: '汽车资讯' },
        ],
    },
];

export const PERMEABILITY_LEVEL = [
    {
        value: 0,
        label: '高渗透率',
        comment: '当前安装已选应用款数最多的用户（排名前30%）',
    },
    {
        value: 1,
        label: '中渗透率',
        comment: '当前安装已选应用款数较多的用户（排名30%-70%）',
    },
    {
        value: 2,
        label: '低渗透率',
        comment: '当前安装已选应用款数较少的用户（排名后30%）',
    },
];

export const INTERESTLEVELLIST = [
    { label: '不限', value: -1 },
    { label: '一般感兴趣人群', value: 1 },
    { label: '非常感兴趣人群', value: 0 },
];

export const PURCHASELEVELLIST = [
    { label: '不限', value: -1 },
    { label: '高消费人群', value: 0 },
    { label: '中消费人群', value: 1 },
    { label: '低消费人群', value: 2 },
];

export const ISPLIST = [
    { label: '移动', value: 1 },
    { label: '联通', value: 2 },
    { label: '电信', value: 3 },
];

export const DEVICE_PRICE_LIST = [
    { label: '0-1000', value: '0-1000' },
    { label: '1001-1500', value: '1001-1500' },
    { label: '1501-2000', value: '1501-2000' },
    { label: '2001-2500', value: '2001-2500' },
    { label: '2501-3000', value: '2501-3000' },
    { label: '3001-3500', value: '3001-3500' },
    { label: '3501-4000', value: '3501-4000' },
    { label: '4001-5000', value: '4001-5000' },
    { label: '5001-6000', value: '5001-6000' },
    { label: '6000+', value: '6000+' },
];

export const TABOPTION = {
    PROFESSIONPERFERENCE: 'profession-preference',
    USERACTION: 'user-action',
    MANAGE: 'manage',
};
